/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Label_Api_UrlInputs */

const fr_label_api_url = /** @type {(inputs: Label_Api_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API URL`)
};

const en_label_api_url = /** @type {(inputs: Label_Api_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API URL`)
};

/**
* | output |
* | --- |
* | "API URL" |
*
* @param {Label_Api_UrlInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const label_api_url = /** @type {((inputs?: Label_Api_UrlInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Label_Api_UrlInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_label_api_url(inputs)
	return en_label_api_url(inputs)
});